import * as React from 'react';
import { CustomButton, ButtonType } from 'soprasteria-ui-library';
import { OrthodonticReferralTreatmentDecisionModal } from '../OrthodonticReferralModals/OrthodonticReferralTreatmentDecisionModal/OrthodonticReferralTreatmentDecisionModal';
import { OrthodonticReferralShareWithConsultationDentalGroupModal } from '../OrthodonticReferralModals/OrthodonticReferralShareWithConsultationDentalGroupModal';
import { OrthodonticReferralShareWithJointConsultationGroupModal } from '../OrthodonticReferralModals/OrthodonticReferralShareWithJointConsultationGroupModal';
import { IPatient } from '../../../../models/IPatient';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';

interface IOrthodonticReferralTreatmentDecisionButtons {
    patient: IPatient;
    orthodonticReferral: IOrthodonticReferral;
    changeSuccessMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    canSendOrthodonticReferralToConsultantDentalGroup: boolean;
    canMakeTreatmentDecision: boolean;
    canSendOrthodonticReferralToJointConsultantGroup: boolean;
    orthodonticReferralAdvancedConsultationNeedId: number;
    isConsultantCareProvider: boolean;
    awaitingDecisionMotivationText?: string;
}

export const OrthodonticReferralTreatmentDecisionButtons: React.FunctionComponent<IOrthodonticReferralTreatmentDecisionButtons> = ({
    patient,
    orthodonticReferral,
    changeSuccessMessage,
    getOrthodonticReferral,
    canSendOrthodonticReferralToConsultantDentalGroup,
    canMakeTreatmentDecision,
    canSendOrthodonticReferralToJointConsultantGroup,
    orthodonticReferralAdvancedConsultationNeedId,
    isConsultantCareProvider,
    awaitingDecisionMotivationText }) => {

    const [renderDecisionForm, setRenderDecisionForm] = React.useState<boolean>(false);
    const [renderShareWithConsultaionDentalGroupForm, setRenderShareWithConsultaionDentalGroupForm] = React.useState<boolean>(false);
    const orthodonticReferralId = orthodonticReferral.orthodonticReferralId ?? 0;

    return (
        <>
            {
                canSendOrthodonticReferralToConsultantDentalGroup ?
                    <>
                        <CustomButton
                            buttonText="Skicka till urvalstandläkargruppen"
                            buttonType={ButtonType.warning}
                            data-target="#orthodontic-referral-share-with-consultation-dental-group-modal"
                            data-toggle="modal"
                            onClick={() => setRenderShareWithConsultaionDentalGroupForm(true)} />
                        <OrthodonticReferralShareWithConsultationDentalGroupModal
                            changeSuccessMessage={changeSuccessMessage}
                            getOrthodonticReferral={getOrthodonticReferral}
                            orthodonticReferralId={orthodonticReferralId}
                            renderForm={renderShareWithConsultaionDentalGroupForm}
                            setRenderForm={setRenderShareWithConsultaionDentalGroupForm} />
                    </>
                    : null
            }
            {
                canSendOrthodonticReferralToJointConsultantGroup ?
                    <>
                        <CustomButton buttonText="Skicka till samrådsgruppen"
                            buttonType={ButtonType.warning}
                            data-target="#orthodontic-referral-share-with-joint-consultation-group-modal"
                            data-toggle="modal" />
                        <OrthodonticReferralShareWithJointConsultationGroupModal
                            changeSuccessMessage={changeSuccessMessage}
                            getOrthodonticReferral={getOrthodonticReferral}
                            orthodonticReferralId={orthodonticReferralId}
                            orthodonticReferralAdvancedConsultationNeedId={orthodonticReferralAdvancedConsultationNeedId}
                            isConsultantCareProvider={isConsultantCareProvider} />
                    </>
                    : null
            }
            {
                canMakeTreatmentDecision ?
                    <>
                        <CustomButton buttonText="Fatta beslut om vård"
                            buttonType={ButtonType.success}
                            data-target="#orthodontic-referral-treatment-decision-modal"
                            data-toggle="modal" onClick={() => setRenderDecisionForm(true)} />
                        <OrthodonticReferralTreatmentDecisionModal
                            orthodonticReferral={orthodonticReferral}
                            patient={patient}
                            changeSuccessMessage={changeSuccessMessage}
                            getOrthodonticReferral={getOrthodonticReferral}
                            awaitingDecisionMotivationText={awaitingDecisionMotivationText}
                            renderForm={renderDecisionForm}
                            setRenderForm={setRenderDecisionForm} />
                    </>
                    : null
            }
        </>
    )
}